import { Component } from '@angular/core';

@Component({
  selector: 'app-read-only-eye',
  templateUrl: './read-only-eye.component.html'
})
export class ReadOnlyEyeComponent {
}
